import React, {Fragment} from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import * as ResourceApi from "api/resources";
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactoryWithAdditionalArgs, createButtonSectionFactory} from "hoc/CreateButtonSection";

import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';
import {enUSmessage} from 'i18n/en-US.js';
import {toParentField} from "utils/DBUtils";
import { isNewLayout } from 'utils/break-utils';

export default {
    name: "mediaUpload",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [

      {
        type: 'hardcodedText',
        showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
        props: {
          heading: 'Shared Elements',
          text: "These items are used on all screens"
        }
      },
      {
        type: 'image',
        name: 'headerImageId',
        required: false,
        idFor: 'headerImage',
        props: {
            labelKey: 'editbreak.steps.receipt_verification.header_image',
            imageType: 'receiptHeader'
        }
      },
      // {
      //   type: 'hardcodedText',
      //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
      //   props: {
      //     heading: 'Legal',
      //   }
      // },
      {
        type: 'contenteditable',
        name: 'stepTerms',
        props: {
          labelKey: 'editbreak.steps.receipt_verification.step_terms'
        }
      },
      //where we are adding somthing
      {
        type: 'text',
        name: 'mediaUploadGroupType',
        required: true,
       
        props: {
          label: "Gallery group to pull from images from. This needs to match what was specified in the upload step. If you're not sure enter the permalink.",
        }
      },
      {
        name: 'hasAddressValidation',
        type: 'yesnoradio',
        required: true,
        props: {
          labelKey: 'Require Physical Address Validation?',
        }
      },

      {
        subSection: true,
        key: "receiptLandingScreen",
        sectionWrapper: IndexedSubSectionWrapper,

        props: {
          innerHeader: true,
          getInnerHeader: () => "Landing Screen / How It Works"
        },
        fields: [
          {
            type: 'contenteditable',
            name: 'headline',
            required: false,
            // Headline is only allowed if there is more than one step
            // showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            showField: true,
            linkedField: (formProxy) => ["title"],
            props: {
                labelKey: 'editbreak.steps.receipt_verification.headline'
            }
          },
          {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.receipt_verification.intro_copy',
              placeholderKey: 'editbreak.steps.receipt_verification.intro_copy.placeholder',
            }
          },
          {
            type: 'text',
            name: 'reminderBtnText',
            required: false,
            showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
            props: {
              labelKey: 'editbreak.steps.receipt_verification.reminder_btn_text'
            }
          },
          // {
          //   type: 'hardcodedText',
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   props: {
          //     heading: 'User Path Selection',
          //   }
          // },
          {
            type: 'text',
            name: 'userPathHeadline',
            required: false,
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
              labelKey: 'User Path Selection Header, e.g. Have a receipt already?'
            }
          },
  
          // {
          //   type: 'text',
          //   name: 'startReminderButtonCopy',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   props: {
          //     labelKey: 'Button Copy - Start Reminder Flow, e.g. "Not Yet"'
          //   }
          // },
          // {
          //   type: 'color',
          //   name: 'startReminderButtonColor',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   linkedField: (formProxy) => ["themeColor3"],
          //   props: {
          //     labelKey: 'Button Color - Start Reminder Flow'
          //   }
          // },
          // {
          //   type: 'color',
          //   name: 'startReminderButtonColor',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   linkedField: (formProxy) => ["themeColor4"],
          //   props: {
          //     labelKey: 'Button Color - Start Reminder Flow'
          //   }
          // },
  
          // {
          //   type: 'text',
          //   name: 'startUploadButtonCopy',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   props: {
          //     labelKey: 'Button Copy - Start Upload Flow, e.g. "Have a Receipt"'
          //   }
          // },
          // {
          //   type: 'color',
          //   name: 'startUploadButtonColor',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   linkedField: (formProxy) => ["themeColor3"],
          //   props: {
          //     labelKey: 'Button Color - Start Upload Flow'
          //   }
          // },
          // {
          //   type: 'color',
          //   name: 'startUploadButtonColor',
          //   required: false,
          //   showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
          //   linkedField: (formProxy) => ["themeColor4"],
          //   props: {
          //     labelKey: 'Button Color - Start Upload Flow'
          //   }
          // },
  
  
          {
            type: 'hardcodedText',
            showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
            props: {
              heading: 'Instructions',
            }
          },

          {
            name: 'instructions',
            resource: true,
            subSection: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
              var receiptCampaign = formProxy.parentCurrentResource;
              return receiptCampaign.instructions && receiptCampaign.instructions.length > 1;
            },
            sortable: true,
            sortableName: "instructionsOrder",
            toggleSortLabelKey: 'editbreak.steps.receipt_verification.instruction.reorder_toggle',
            resourceType: ResourceApi.Types.ReceiptCampaignStepInstruction,

            props: {
                headerKey: 'editbreak.steps.receipt.instruction.header',
                getCustomSectionHeader: (instruction, sectionIndex) => {
                    return   "Instruction " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
                }
            },

            footerContent: createButtonSectionFactoryWithAdditionalArgs({
                instructionListName: "instructions"
            }, ResourceApi.Types.ReceiptCampaignStepInstruction),

            fields: [
                {
                    name: 'headline',
                    type: 'contenteditable',
                    required: true,
                    props: {
                        labelKey: 'editbreak.steps.receipt_verification.instruction.headline'
                    }
                },
                {
                    type: 'color',
                    name: 'headlineTextClr',
                    showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                    required: true,
                    props: {
                      labelKey: 'editbreak.steps.receipt_verification.instruction.headline_text_color'
                    }
                },
                {
                  type: 'contenteditable',
                  name: 'desc',
                  required: false,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.description'
                  }
                },
                {
                  conditionalSection: true,
                  name: "addDetails",
                  required: false,
                  props: {
                      labelKey: 'editbreak.steps.receipt_verification.instruction.add_details'
                  },

                  fields: [
                    {
                      type: 'contenteditable',
                      name: 'detailHeadline',
                      required: true,
                      showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.instruction.detail_headline'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'detailDesc',
                      required: false,
                      showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.instruction.detail_description'
                      }
                    },
                    {
                      type: 'image',
                      name: 'detailImageId',
                      idFor: 'detailImage',
                      required: false,
                      showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.instruction.detail_image',
                        imageType: 'receiptDetailInstruction'
                      }
                    },
                    {
                      type: 'color',
                      name: 'detailBackgroundClr',
                      required: false,
                      showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.instruction.detail_bg_color'
                      }
                    },
                    // SAME FIELD NAMES, DIFFERENT LABELS
                    {
                      type: 'contenteditable',
                      name: 'detailHeadline',
                      required: false,
                      showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'Detail CTA Copy, e.g. See More'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'detailDesc',
                      required: false,
                      showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                      props: {
                        labelKey: 'Detail copy (modal copy)'
                      }
                    },

                  ]
                },// end add details conditional
                {
                  type: 'radio',
                  name: "iconType",
                  required: false,
                  props: {
                      labelKey: 'editbreak.steps.receipt_verification.instruction.icon_type',
                      options: [
                        {
                          value: 'Icon',
                          textKey: 'editbreak.steps.receipt_verification.instruction.icon_type.icon'
                        },
                        {
                          value: 'Image',
                          textKey: 'editbreak.steps.receipt_verification.instruction.icon_type.image'
                        },
                        {
                          value: 'SVG',
                          textKey: 'Pasted SVG'
                        }
                      ]
                  }
                },
                // {
                //   type: 'imageurl',
                //   name: 'imageUrl',
                //   required: false,
                //   // showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                //   props: {
                //     labelKey: 'Icon Image URL'
                //   }
                // },
                {
                  type: 'textarea',
                  name: 'svg',
                  required: true,
                  showField: (proxy) => (proxy.currentResource.iconType === 'SVG'),
                  props: {
                    labelKey: 'Paste SVG Code'
                  }
                },
                {
                  type: 'text',
                  name: 'iconId',
                  required: false,
                  showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.icon.id'
                  }
                },
                {
                  type: 'color',
                  name: 'iconFontClr',
                  required: false,
                  linkedField: (formProxy) => ["themeColor4"],
                  showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.icon.color'
                  }
                },
                {
                  type: 'number',
                  name: 'iconSize',
                  required: false,
                  showField: (proxy) => ((proxy.currentResource.iconType === 'Icon') && !isNewLayout(proxy.currentBaseResource)),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.icon.size'
                  }
                },
                {
                  type: 'color',
                  name: 'iconBackgroundClr',
                  required: false,
                  linkedField: (formProxy) => ["themeColor3"],
                  showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.icon.bg_color'
                  }
                },
                {
                  type: 'color',
                  name: 'iconBackgroundClrHover',
                  required: false,
                  linkedField: (formProxy) => ["themeColor3"],
                  showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                  props: {
                    labelKey: 'Icon Background Color (Hover)'
                  }
                },
                {
                  type: 'color',
                  name: 'iconBorderClr',
                  required: false,
                  linkedField: (formProxy) => ["themeColor4"],
                  showField: (proxy) => (proxy.currentResource.iconType === 'Icon'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.icon.border_color'
                  }
                },
                {
                  type: 'image',
                  name: 'iconId',
                  idFor: 'icon',
                  required: true,
                  showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.image',
                    imageType: 'receiptDetailInstruction'
                  }
                },
                {
                  type: 'color',
                  name: 'iconBackgroundClr',
                  required: true,
                  showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.image.bg_color'
                  }
                },
                {
                  type: 'color',
                  name: 'iconBorderClr',
                  required: true,
                  showField: (proxy) => (proxy.currentResource.iconType === 'Image'),
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.instruction.image.border_color'
                  }
                },

            ]
          },

        ]
      },

        {
          subSection: true,
          key: "receiptSubmissionRewards3",
          sectionWrapper: IndexedSubSectionWrapper,
          props: {
            // 'headerKey': 'editbreak.steps.lead_gen.thanks.header'
            innerHeader: true,
            getInnerHeader: () => "Categories & Category-Specific Copy"
          },          
          fields: [
            {
              type: 'text',
              name: 'rewardSelectionLabel',
              required: false,
              props: {
                labelKey: 'Category Selection Label, e.g. Select Your Occassion'
              }
            },
  
            {
              name: 'rewards',
              
              resource: true,
              subSection: true,
              collection: true,
              
              sectionWrapper: IndexedSubSectionWrapper,
              sortable: true,
              sortableName: "rewardsOrder",
              toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
              deletable: true,
              canDelete: (formProxy) => {
                return true
              },
              resourceType: ResourceApi.Types.ReceiptCampaignReward,
  
              props: {
                  headerKey: 'editbreak.steps.receipt.requirements.header',
                  getCustomSectionHeader: (reward, sectionIndex) => {
                      return (reward.title ? reward.title : "Category " + (sectionIndex + 1)) ;
                  }
              },
  
              footerContent: createButtonSectionFactory(ResourceApi.Types.ReceiptCampaignReward),
  
              fields: [
                {
                  type: 'currentId',
                  name: 'id',
                  label: 'Category ID'
                },
                {
                  type: 'contenteditable',
                  name: 'title',
                  required: false,
                  props: {
                    labelKey: 'Title'
                  }
                },
                {
                  type: 'image',
                  name: 'rewardImageId',
                  required: false,
                  idFor: 'rewardImage',
                  props: {
                      labelKey: 'Header Image',
                      imageType: 'receiptHeader'
                  }
                },
                // {
                //   type: 'contenteditable',
                //   name: 'confirmationCopy',
                //   required: false,
                //   props: {
                //     labelKey: 'Custom Confirmation Copy (optional)'
                //   }
                // },          
                {
                  type: 'hardcodedText',
                  showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                  props: {
                    heading: 'Form Submission Screen',
                  }
                },


                {
                  type: 'yesnoradio',
                  name: 'requireName',
                  required: true,
                  props: {
                    labelKey: 'Require First and Last name'
                  }
                },

                {
                  type: 'yesnoradio',
                  name: 'requireAddress',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.receipt_verification.reward_section.require_address'
                  }
                },

                {
                  type: 'yesnoradio',
                  name: 'requirePhoneNumber',
                  required: true,
                  props: {
                    labelKey: 'Require Phone Number'
                  }
                },

                {
                  name: "confirmations",
                  subSection: true,
                  resource: true,
                  collection: true,
                  sectionWrapper: IndexedSubSectionWrapper,
                  deletable: true,
                  canDelete: (formProxy) => {
                    // logic like this would force at least one item
                    //   var parentReview = formProxy.parentCurrentResource;
                    //   return parentReview.products && parentReview.products.length > 1;
                        return true
                  },
                  sortable: true,
                  sortableName: "confirmationsOrder",
                  resourceType: ResourceApi.Types.MediaUploadConfirmation,
                  toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
                  props: {
                    // headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                    getCustomSectionHeader: (item, sectionIndex) => {
                        return `Confirmation ${ (sectionIndex + 1) }`
                      // return item.label ? item.label : `Link - ${ (sectionIndex + 1) }`
                      // return product.dropdownTitle
                      // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                    }
                  },
              
        
                  // footerContent: createButtonSectionFactory(ResourceApi.Types.MediaUploadConfirmation),
                  footerContent: createButtonSectionFactoryWithAdditionalArgs({
                    instructionListName: "confirmations"
                  }, ResourceApi.Types.MediaUploadConfirmation),
    

                  fields: [
                    // {
                    //   type: "text",
                    //   name: "name",
                    //   required: false,
                    //   props: {
                    //     labelKey: "Internal Name",
                    //     validationRules: [
                    //         {
                    //             type: 'PermalinkFormat'
                    //         }
                    //     ]
                    // }
                    // },
                    {
                      type: "contenteditable",
                      name: "text",
                      required: false,
                      props: {
                        labelKey: "Text",
                      },
                    },
                    {
                      type: "yesnoradio",
                      name: "required",
                      required: false,
                      props: {
                        labelKey: "Must be checked to continue",
                      },
                    },

                    
        
                  ],
                },                



                // {
                //   subSection: true,
                //   key: 'receiptSubmissionRewardsCopy',
                //   index: 85,
                //   sectionWrapper: IndexedSubSectionWrapper,
                //   props: {
                //     innerHeader: true,
                //     getInnerHeader: () => "Thank You Screen"
                //   },
                //   fields: [
                  {
                    type: 'hardcodedText',
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      heading: 'Thank You Screen',
                    }
                  },
                          
                    {
                        type: 'contenteditable',
                        name: 'thankyouHeader',
                        required: false,
                        props: {
                          labelKey: 'Thank-You - Header'
                        }
                    },
                    {
                        type: 'contenteditable',
                        name: 'thankyouBody',
                        required: false,
                        props: {
                          labelKey: 'Thank-You - Body'
                        }
                    },
                //   ]
                // },

                // {
                //   subSection: true,
                //   key: 'receiptSubmissionRewardsStatusCopy',
                //   index: 85,
                //   sectionWrapper: IndexedSubSectionWrapper,
                //   props: {
                //     innerHeader: true,
                //     getInnerHeader: () => "Receipt Status Screen"
                //   },
                //   fields: [
                  {
                    type: 'hardcodedText',
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      heading: 'Receipt Status Screen',
                    }
                  },                          
                    {
                        type: 'contenteditable',
                        name: 'approvedHeader',
                        required: false,
                        props: {
                          labelKey: 'Approved - Header'
                        }
                    },
                    {
                        type: 'contenteditable',
                        name: 'approvedBody',
                        required: false,
                        props: {
                          labelKey: 'Approved - Body'
                        }
                    },
                    {
                        type: 'contenteditable',
                        name: 'rejectedHeader',
                        required: false,
                        props: {
                          labelKey: 'Rejected - Header'
                        }
                    },
                    {
                        type: 'contenteditable',
                        name: 'rejectedBody',
                        required: false,
                        props: {
                          labelKey: 'Rejected - Body'
                        }
                    },

                    {
                      type: 'text',
                      name: 'statusScreenButtonCopy',
                      required: false,
                      props: {
                        labelKey: 'Button Copy'
                      }
                    },
                    {
                      type: 'text',
                      name: 'statusScreenButtonUrl',
                      required: false,
                      props: {
                        labelKey: 'Button URL'
                      }
                    },
        
                //   ]
                // },

                // {
                //   subSection: true,
                //   name: 'submittedEmailData',
                //   // resource: true,
                //   sectionWrapper: IndexedSubSectionWrapper,
                //   props: {
                //     innerHeader: true,
                //     getInnerHeader: () => <Fragment><FormattedMessage id={'editbreak.steps.receipt_verification.submitted_email_data'}/></Fragment>
                //   },
                //   fields: [
                  {
                    type: 'hardcodedText',
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      heading: 'Submission Received Email',
                      text: "Sent immediately to a consumer when they submit a receipt. Will include a link to check the status of their submission."
                    }
                  },                    
                  {
                    type: 'text',
                    name: 'submittedEmailSubject',
                    required: false,
                    props: {
                      labelKey: 'Subject'
                    }
                  },
                  {
                      type: 'contenteditable',
                      name: 'submittedEmailTitle',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.title'
                      }
                  },
                  {
                      type: 'contenteditable',
                      name: 'submittedEmailBody',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.body'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'submittedEmailFooter',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.submitted_email_data.footer'
                      }
                    },
                //   ]
                // }, 

                // {
                //   subSection: true,
                //   name: 'approvedEmailData',
                  
                //   sectionWrapper: IndexedSubSectionWrapper,
                //   props: {
                //     innerHeader: true,
                //     getInnerHeader: () => <Fragment><FormattedMessage id={'editbreak.steps.receipt_verification.approved_email_data'}/></Fragment>
                //   },
                //   fields: [
                  {
                    type: 'hardcodedText',
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      heading: 'Submission Approved Email',
                    }
                  },
                  {
                    type: 'text',
                    name: 'approvedEmailSubject',
                    required: false,
                    props: {
                      labelKey: 'Subject'
                    }
                  },                  
                  {
                      type: 'contenteditable',
                      name: 'approvedEmailTitle',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.approved_email_data.title'
                      }
                    },
                    // {
                    //   type: 'image',
                    //   name: 'approvedEmailImageId',
                    //   idFor: 'approvedEmailImage',
                    //   required: false,
                    //   props: {
                    //     labelKey: 'Image',
                    //     imageType: 'receiptHeader' 
                    //   }
                    // },
        
                    {
                      type: 'contenteditable',
                      name: 'approvedEmailBody',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.approved_email_data.body'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'approvedEmailFooter',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.approved_email_data.footer'
                      }
                    },


                    {
                    type: 'hardcodedText',
                    showField: (proxy) =>  (isNewLayout(proxy.currentBaseResource)),
                    props: {
                      heading: 'Rejected Email',
                      text: "Sent to a consumer when their submission is rejected in the admin tool."
                    }
                  },
                  {
                    type: 'text',
                    name: 'rejectedEmailSubject',
                    required: true,
                    props: {
                      labelKey: 'Subject'
                    }
                  },
                  {
                      type: 'contenteditable',
                      name: 'rejectedEmailTitle',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.title'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'rejectedEmailBody',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.body'
                      }
                    },
                    {
                      type: 'contenteditable',
                      name: 'rejectedEmailFooter',
                      required: true,
                      props: {
                        labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.footer'
                      }
                    },
                    // {
                    //   type: 'image',
                    //   name: 'clientLogoId',
                    //   idFor: 'clientLogo',
                    //   required: false,
                    //   props: {
                    //     labelKey: 'editbreak.steps.receipt_verification.rejected_email_data.client_logo',
                    //     imageType: 'clientLogo'
                    //   }
                    // }
                //   ]
                // } 

              ]
            }
  
          ]
        },
  

        {
          subSection: true,
          key: "uploadScreen",
          index: 10,
          sectionWrapper: IndexedSubSectionWrapper,

          props: {
            innerHeader: true,
            getInnerHeader: () => 'Upload Screen'
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'uploadHeadline',
              required: false,
              props: {
                labelKey: 'Headline'
              }
            },
            {
              type: 'contenteditable',
              name: 'uploadIntroCopy',
              required: false,
              props: {
                labelKey: 'Intro Copy'
              }
            },
            {
              type: 'yesnoradio',
              name: 'allowVideoUpload',
              required: true,
              props: {
                labelKey: 'Allow Video Upload'
              }
            },
            {
              type: 'yesnoradio',
              name: 'allowPhotoUpload',
              required: true,
              props: {
                labelKey: 'Allow Photo Upload'
              }
            },
            {
                type: 'text',
                name: 'groupType',
                required: false,
                props: {
                  labelKey: 'Group Type'
                }
              },
  
          ]
        },

        // Review your Submissions
        {
          subSection: true,
          key: "receiptRequirements",
          sectionWrapper: IndexedSubSectionWrapper,

          props: {
            innerHeader: true,
            getInnerHeader: () => <Fragment>Review Submission Screen (Form)</Fragment>
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'detailedInstructionsHeader',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'detailedInstructionsCopy',
              required: false,
              props: {
                labelKey: 'Body Copy'
              }
            },
            
            {
              type: 'text',
              name: 'submissionFormTitleLabel',
              required: false,
              props: {
                labelKey: 'Form label for Title field, e.g. Pet Name or Title'
              }
            },

            {
              type: 'text',
              name: 'submissionFormCaptionLabel',
              required: false,
              props: {
                labelKey: 'Form label for Caption field, e.g. Caption'
              }
            },

            {
              type: 'contenteditable',
              name: 'detailedInstructionsRequiredItemListHeader',
              required: false,
              props: {
                labelKey: 'Required Item List Header'
              }
            },
            {
              name: 'detailedInstructions',
              resource: true,
              subSection: true,
                collection: true,
              sectionWrapper: IndexedSubSectionWrapper,
                sortable: true,
                sortableName: "detailedInstructionsOrder",
                toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
              deletable: true,
              deleteAdditionalArgs: () => ({instructionListName: "reminderInstructions"}),
              additionalData: {"foo": "foo1"},
              canDelete: (formProxy) => {
                var receiptCampaign = formProxy.parentCurrentResource;
                return receiptCampaign.detailedInstructions && receiptCampaign.detailedInstructions.length > 1;
              },
              resourceType: ResourceApi.Types.ReceiptCampaignDetailedInstruction,

              props: {
                  headerKey: 'editbreak.steps.receipt.requirements.header',
                  getCustomSectionHeader: (instruction, sectionIndex) => {
                      return   "Requirement Item " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
                  },
                  additionalData: {"bar": "bar1"},
              },

              footerContent: createButtonSectionFactoryWithAdditionalArgs({
                  instructionListName: "detailedInstructions"
              }, ResourceApi.Types.ReceiptCampaignDetailedInstruction),

              fields: [
                  {
                    type: 'contenteditable',
                    name: 'desc',
                    additionalData: {"baz": "baz1"},
                    args: {buz: "buz1" },
                    required: true,
                    props: {
                      labelKey: 'editbreak.steps.receipt_verification.requirement.description',
                      args: {qux: "qux1" },
                    }
                  }
              ]
            }
          ]
        },  // end requirements accordion
        {
          subSection: true,
          key: "receiptReminder",
          sectionWrapper: IndexedSubSectionWrapper,

          props: {
            innerHeader: true,
            getInnerHeader: () => <Fragment>Set a Reminder Screen</Fragment>
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'reminderHeader',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderCopy',
              required: false,
              props: {
                labelKey: 'Body Copy'
              }
            },
          ]
        },        
        {
          subSection: true,
          key: "receiptReminderThanks",
          sectionWrapper: IndexedSubSectionWrapper,

          props: {
            innerHeader: true,
            getInnerHeader: () => <Fragment>Reminder Thank You Screen</Fragment>
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'reminderThanksHeader',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderThanksCopy',
              required: false,
              props: {
                labelKey: 'Body Copy'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderThanksInstructionsHeader',
              required: false,
              props: {
                labelKey: 'Item List Header (e.g. How it works)'
              }
            },
            {
              name: 'reminderInstructions',
              resource: true,
              subSection: true,
                collection: true,
              sectionWrapper: IndexedSubSectionWrapper,
                sortable: true,
                sortableName: "reminderInstructionsOrder",
                toggleSortLabelKey: 'editbreak.steps.receipt_verification.requirements.reorder_toggle',
              deletable: true,
              deleteAdditionalArgs: () => ({instructionListName: "reminderInstructions"}),
              additionalData: {"foo": "foo1"},
              canDelete: (formProxy) => {
                var receiptCampaign = formProxy.parentCurrentResource;
                return receiptCampaign.reminderInstructions && receiptCampaign.reminderInstructions.length > 1;
              },
              resourceType: ResourceApi.Types.ReceiptCampaignReminderInstruction,

              props: {
                  headerKey: 'editbreak.steps.receipt.requirements.header',
                  getCustomSectionHeader: (instruction, sectionIndex) => {
                      return   "Instruction " + (sectionIndex + 1) + (instruction.headline ? ": " + instruction.headline : "");
                  },
                  additionalData: {"bar": "bar1"},
                },

              footerContent: createButtonSectionFactoryWithAdditionalArgs({
                  instructionListName: "reminderInstructions"
              }, ResourceApi.Types.ReceiptCampaignReminderInstruction),

              fields: [
                  {
                    type: 'contenteditable',
                    name: 'desc',
                    required: true,
                    props: {
                      labelKey: 'Copy',
                      additionalData: {"baz": "baz1"},
                    }
                  }
              ]
            }

          ]
        },

        {
          subSection: true,
          key: "receiptReminderEmails",
          sectionWrapper: IndexedSubSectionWrapper,
          showSection: (proxy) => (isNewLayout(proxy.currentBaseResource)),
          props: {
            innerHeader: true,
            getInnerHeader: () => <Fragment>Reminder Emails</Fragment>
          },
          fields: [
            {
              type: 'hardcodedText',
              props: {
                heading: 'Reminder Setup Email',
                text: "Reminder Setup is sent immediately when a consumer requests a reminder to confirm that they are all set."
              }
            },
            {
              type: 'text',
              name: 'reminderSetupEmailSubject',
              required: false,
              props: {
                labelKey: 'Subject'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderSetupEmailTitle',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            // {
            //   type: 'image',
            //   name: 'reminderSetupEmailImageId',
            //   idFor: 'reminderSetupEmailImage',
            //   required: false,
            //   props: {
            //     labelKey: 'Image',
            //     imageType: 'receiptHeader' 
            //   }
            // },
            {
              type: 'contenteditable',
              name: 'reminderSetupEmailBody',
              required: false,
              props: {
                labelKey: 'Body'
              }
            },
            {
              type: 'text',
              name: 'reminderSetupEmailButtonCopy',
              required: false,
              props: {
                labelKey: 'Button Copy'
              }
            },
            {
              type: 'text',
              name: 'reminderSetupEmailButtonUrl',
              required: false,
              props: {
                labelKey: 'Button URL'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderSetupEmailFooter',
              required: false,
              props: {
                labelKey: 'Footer'
              }
            },

            // 
            {
              type: 'hardcodedText',
              props: {
                heading: 'Reminder Email',
              }
            },
            {
              type: 'text',
              name: 'reminderEmailSubject',
              required: false,
              props: {
                labelKey: 'Subject'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderEmailTitle',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            // {
            //   type: 'image',
            //   name: 'reminderEmailImageId',
            //   idFor: 'reminderEmailImage',
            //   required: false,
            //   props: {
            //     labelKey: 'Image',
            //     imageType: 'receiptHeader' 
            //   }
            // },
            {
              type: 'contenteditable',
              name: 'reminderEmailBody',
              required: false,
              props: {
                labelKey: 'Body'
              }
            },
            {
              type: 'text',
              name: 'reminderEmailButtonCopy',
              required: false,
              props: {
                labelKey: 'Button Copy'
              }
            },
            {
              type: 'text',
              name: 'reminderEmailButtonUrl',
              required: false,
              props: {
                labelKey: 'Button URL'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminderEmailFooter',
              required: false,
              props: {
                labelKey: 'Footer'
              }
            },



            // 
            {
              type: 'hardcodedText',
              props: {
                heading: 'Second Reminder Email',
              }
            },
            {
              type: 'text',
              name: 'reminder2EmailSubject',
              required: false,
              props: {
                labelKey: 'Subject'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminder2EmailTitle',
              required: false,
              props: {
                labelKey: 'Header'
              }
            },
            // {
            //   type: 'image',
            //   name: 'reminder2EmailImageId',
            //   idFor: 'reminder2EmailImage',
            //   required: false,
            //   props: {
            //     labelKey: 'Image',
            //     imageType: 'receiptHeader' 
            //   }
            // },
            {
              type: 'contenteditable',
              name: 'reminder2EmailBody',
              required: false,
              props: {
                labelKey: 'Body'
              }
            },
            {
              type: 'text',
              name: 'reminder2EmailButtonCopy',
              required: false,
              props: {
                labelKey: 'Button Copy'
              }
            },
            {
              type: 'text',
              name: 'reminder2EmailButtonUrl',
              required: false,
              props: {
                labelKey: 'Button URL'
              }
            },
            {
              type: 'contenteditable',
              name: 'reminder2EmailFooter',
              required: false,
              props: {
                labelKey: 'Footer'
              }
            },



          ]
        },
        {
          subSection: true,
          key: 'receiptSubmissionSection',
          sectionWrapper: IndexedSubSectionWrapper,
          props: {
            innerHeader: true,
            getInnerHeader: () => <Fragment><FormattedMessage id={`editbreak.steps.media_upload.innerHeading`}/><FormattedMessage id={'editbreak.steps.receipt_verification.submission_section'}/></Fragment>
          },
          fields: [
            {
              type: 'contenteditable',
              name: 'waitingDescription',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.submission.verification_pending_text'
              }
            },
            {
              type: 'number',
              name: 'legalSubmissionLimit',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.submission.submission_limit'
              }
            },
            {
              type: 'datetime',
              name: 'uploadByDate',
              required: true,
              props: {
                labelKey: 'editbreak.steps.receipt_verification.submission.submission_cutoff'
              }
            },
              {
                  type: 'text',
                  pathOverride: toParentField("nextBreakIds"),
                  showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                      labelKey: 'editbreak.steps.receipt_verification.nextBreakIds',
                      asList: true
                  }
              },
              {
                  type: 'text',
                  pathOverride: toParentField("excludeNextBreakIdList"),
                  showField: (proxy) =>  (!isNewLayout(proxy.currentBaseResource)),
                  props: {
                      labelKey: 'editbreak.steps.receipt_verification.excludeNextBreakIdList',
                      asList: true
                  }
              }
          ]
        },

    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/media-upload.js